import { Task } from "../../components/task/Task"
import { useState, useEffect } from "react";
import { Language } from "../../context/LanguageContext";
import { translations } from "../../configs/translations";
import './Battlepass.css'
import { formatTextWithParams } from "../../utils/formatTextWithParams";
import { animNumber } from "../../utils/animNumber";
import { useNavigate } from "react-router-dom";

export const Battlepass = () => {
    const [language, setLanguage] = useState<Language>('ru');
    const t = translations[language];

    const [task1Number, setTask1Number] = useState<number | null>(null);
    const [task2Number, setTask2Number] = useState<number | null>(null);
    const [task3Number, setTask3Number] = useState<number | null>(null);
    const [exp, setExp] = useState<number | null>(null);

    const [isExiting, setIsExiting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
          if (event.key === 'Escape') {
            setIsExiting(true);
            setTimeout(() => {
              navigate('/main');
            }, 500);
          }
        };
    
        window.addEventListener('keydown', handleEsc);
        return () => {
          window.removeEventListener('keydown', handleEsc);
        };
    }, [navigate]);

    useEffect(() => {
        if (!task1Number) {
            animNumber(0, 29000000, 1000, setTask1Number);
        }
        if (!task2Number) {
            animNumber(0, 1, 1000, setTask2Number);
        }
        if (!task3Number) {
            animNumber(0, 100, 1000, setTask3Number);
        }
        if (!exp) {
            animNumber(0, 350, 1000, setExp);
        }
    }, []);

    return (
        <div className="battlepass-page-wrapper">
            <img 
                src="/battlepass/abstract_bg.png" 
                alt="battlepass-background" 
                className="battlepass-background" 
            />
            <div className="battlepass-page">
                <div className="battlepass-header">
                    <div className="battlepass-header-left">
                        <h1 className="battlepass-header-left-h1">Сезонный попуск</h1>

                        <div className="battlepass-header-left-level-tasks">
                            <Task 
                                type="battlepass-level-card" 
                                lvl={152}
                                lvlName="Золотой"
                                exp={exp || 0}
                                maxExp={1000}
                            />
                            <Task 
                                title={t.bp_until_event_ends} 
                                description={"123" + " " + t.dn}
                                type="just-text" 
                            />
                        </div>

                        <div className="battlepass-header-left-tasks">
                            <Task
                                title={formatTextWithParams(t.task_participate_in_x_races, [30000000]) +
                                    formatTextWithParams(t.task_participate_in_x_races, [30000000])
                                } 
                                type="big" 
                                exp={task1Number || 0}
                                maxExp={30000000}
                            />
                        </div>

                        <div className="battlepass-header-left-tasks">
                            <Task
                                title={formatTextWithParams(t.task_participate_in_x_races, [3])} 
                                description={"Описание "}
                                type="big" 
                                exp={task2Number || 0}
                                maxExp={3}
                            />
                        </div>

                        <div className="battlepass-header-left-tasks">
                            <Task
                                title={formatTextWithParams(t.task_participate_in_x_races, [300])} 
                                type="big" 
                                exp={task3Number || 0}
                                maxExp={300}
                            />
                        </div>

                    </div>

                    <div className="battlepass-header-right">
                        <img className="battlepass-header-right-image" src="/cars/m5f902020.png" alt="m5f902020" />
                        
                        <div className="battlepass-header-picture-title">
                            <h1 className="battlepass-header-picture-text">
                                Porsche 911
                            </h1>
                            <p className="battlepass-header-picture-subtext">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod.
                            </p>
                        </div>
                    </div>
                                
                </div>

                <div className="battlepass-body">
                    
                    <div className="battlepass-body-title">
                        <h1 className="vertical-title">{t.premium}</h1>
                        <h1 className="vertical-title">{t.standard}</h1>
                    </div>

                    <div className="battlepass-line">

                        <div className="battlepass-line-item">
                            
                            <div className="battlepass-line-item-prize-box">
                                <div className="battlepass-prize-container">
                                    <div className='battlepass-prize'
                                    style={{
                                        width: '140px',
                                        height: '140px',
                                    }}>
                                        <img src={`/battlepass/prizes/m5f90.png`} alt={'m5f90'} />
                                        <p>{'m5f90'}</p>
                                    </div>
                                </div>

                                <div className="battlepass-prize-horizontal-line"></div>

                                <div className="battlepass-prize-container">
                                    <div className="battlepass-prize">
                                        <img src={`./battlepass/prizes/m5f90.png`} alt={'m5f90'} />
                                        <p>{'m5f90'}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="battlepass-line-item-lvl-box">
                                <h1>1</h1>
                                <div className="battlepass-line-item-lvl-box-progress" style={{ width: '100%' }}></div>
                            </div>
                        </div>

                        <div className="battlepass-line-item">
                            
                            <div className="battlepass-line-item-prize-box">
                            </div>

                            <div className="battlepass-line-item-lvl-box">
                                <h1>1</h1>
                                <div className="battlepass-line-item-lvl-box-progress" style={{ width: '100%' }}></div>
                            </div>
                        </div>

                        {
                            Array.from({ length: 15 }).map((_, index) => (
                                <div className="battlepass-line-item">
                            
                                <div className="battlepass-line-item-prize-box">
                                    <div className="battlepass-prize-container">
                                        <div className='battlepass-prize'
                                        style={{
                                            width: '140px',
                                            height: '140px',
                                        }}>
                                            <img src={`/battlepass/prizes/m5f90.png`} alt={'m5f90'} />
                                            <p>{'m5f90'}</p>
                                        </div>
                                    </div>
    
                                    <div className="battlepass-prize-horizontal-line"></div>
    
                                    <div className="battlepass-prize-container">
                                        <div className="battlepass-prize">
                                            <img src={`./battlepass/prizes/m5f90.png`} alt={'m5f90'} />
                                            <p>{'m5f90'}</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div className="battlepass-line-item-lvl-box">
                                    <h1>1</h1>
                                    <div className="battlepass-line-item-lvl-box-progress" style={{ width: '100%' }}></div>
                                </div>
                            </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}